import type { ComponentSchema } from '../../../../../schema-types'

/** Pathok checkout: billing details, delivery area, cash on delivery and the order summary. Keys follow lightings-1. */
export const schema: ComponentSchema = {
  type: 'checkout',
  label: 'Checkout',
  description: 'Billing details, delivery area, payment and order summary with a place-order button.',
  supportedPages: ['checkout'],
  variants: [{ id: 'v1', label: 'Two columns' }],
  commonFields: [
    { key: 'pageTitle', label: 'Billing title', type: 'string', default: 'Billing details' },
    { key: 'emptyTitle', label: 'Empty cart title', type: 'string', default: 'Your cart is empty.' },
    { key: 'emptyMessage', label: 'Empty cart message', type: 'string' },
    { key: 'continueShoppingText', label: 'Continue shopping text', type: 'string', default: 'Return to shop' },
    { key: 'continueShoppingLink', label: 'Continue shopping link', type: 'string', default: '/shop' },
    { key: 'summaryTitle', label: 'Order summary title', type: 'string', default: 'Your order' },
    { key: 'subtotalLabel', label: 'Subtotal label', type: 'string', default: 'Subtotal' },
    { key: 'deliveryLabel', label: 'Delivery label', type: 'string', default: 'Delivery' },
    { key: 'totalLabel', label: 'Total label', type: 'string', default: 'Total' },
    { key: 'codLabel', label: 'Cash on delivery label', type: 'string', default: 'Cash on delivery' },
    { key: 'codDescription', label: 'How to pay (cash on delivery)', type: 'localized-text', default: 'Pay with cash when your order arrives.' },
    { key: 'privacyNote', label: 'Privacy note', type: 'localized-text', help: 'Shown above the place-order button. Leave empty for the default note linking to the privacy policy.' },
    { key: 'placeOrderText', label: 'Place order button text', type: 'string', default: 'Place order' },
    { key: 'placingOrderText', label: 'Placing order text', type: 'string', default: 'Placing order…' },
  ],
}
